import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  deletePriceBook: null,
  loading: false,
  error: null,
};

const deletePriceBookSlice = createSlice({
  name: "deletePriceBook",
  initialState,
  reducers: {
    fetchDeletePriceBookSuccess: (state, action) => {
      state.loading = false;
      state.deletePriceBook = action.payload;
      state.error = null;
    },

    fetchDeletePriceBookFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    fetchDeletePriceBookStart: (state) => {
      state.loading = true;
      state.error = null;
    },
  },
});

export const {
  fetchDeletePriceBookSuccess,
  fetchDeletePriceBookFailure,
  fetchDeletePriceBookStart,
} = deletePriceBookSlice.actions;

export default deletePriceBookSlice.reducer;